import { h } from 'preact';

// Font Awesome Pro 5.15.4 duotone "ghost" -- the shadow-ban marker moderators see on a hidden comment.
// Both paths default to currentColor, the theme's text colour beside it, so the ghost reads on any
// store background, light or dark -- fixed brand colours washed out on dark themes. The body is the
// duotone's 40% layer and the eyes are solid. Sizes and fills are inline styles for the same reason
// as icon-check-badge: a store theme's svg rules outrank bare attributes.
export function IconGhost({
  width = 14,
  height = 14,
  bodyFill = 'currentColor',
  eyeFill = 'currentColor',
}) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 384 512"
      width={width}
      height={height}
      style={{ width: `${width}px`, height: `${height}px` }}
      class="icon-ghost"
    >
      <path
        opacity=".4"
        fill={bodyFill}
        style={{ fill: bodyFill }}
        d="M186.1.09C81 3.24 0 94.92 0 200.05V464a16 16 0 0 0 27.31 11.31l24.92-18.53A16 16 0 0 1 73.74 459l43 48.35a16 16 0 0 0 22.63 0L180 461.46a16 16 0 0 1 23.92 0l40.72 45.85a16 16 0 0 0 22.63 0L310.26 459a16 16 0 0 1 21.51-2.21l24.92 18.53C366.77 485.36 384 478.22 384 464V192C384 84 294.83-3.17 186.1.09zM128 224a32 32 0 1 1 32-32 32 32 0 0 1-32 32zm128 0a32 32 0 1 1 32-32 32 32 0 0 1-32 32z"
      />
      <path
        fill={eyeFill}
        style={{ fill: eyeFill }}
        d="M128 160a32 32 0 1 0 32 32 32 32 0 0 0-32-32zm128 0a32 32 0 1 0 32 32 32 32 0 0 0-32-32z"
      />
    </svg>
  );
}
